<mat-grid-list cols="3" rowHeight="2:1">
    <mat-grid-tile *ngFor="let navElement of dataSource; last as last" routerLink="{{navElement.path}}"> 
        <div class="text-center">
            <mat-icon matListIcon>{{navElement.icon}}</mat-icon>
            <div>{{ navElement.title }}</div>
        </div>    
    </mat-grid-tile>
</mat-grid-list>